import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { ApiDataResponse } from '@/shared/models/api-response.interface';
import { Quartier } from '../interfaces/quartier.interface';

@Injectable({
  providedIn: 'root',
})
export class SpatialUnitGroupService {
  constructor(private httpClient: HttpClient) {}

  get headers() {
    return {
      Accept: 'application/json',
    };
  }

  getQuartiers(
    page: number = 0,
    size: number = 10,
    keyword: string | null = null
  ): Observable<ApiDataResponse<Quartier>> {
    const params = new URLSearchParams({
      page: page.toString(),
      size: size.toString(),
    });

    if (keyword) {
      params.append('searchKey', keyword);
    }

    return this.httpClient.get<ApiDataResponse<Quartier>>(
      `${environment.PORTAL_API_URL}/spatialunitgroup/villages?${params.toString()}`,
      { headers: this.headers }
    );
  }
}
